import { useNavigate } from "react-router-dom";

const ProtectedRoute = ({ children }) => {
  const token = localStorage.getItem("token");
  const Navigate = useNavigate();

  // If no token, redirect to login
  if (!token) {
    return Navigate("/");
  }

  // Otherwise, render protected content
  return children;
};

export default ProtectedRoute;
